import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';

import styled from 'styled-components';

export default function ToMain() {
  const [isMain, setIsMain] = useState(window.location.pathname === '/');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIsMain(location.pathname === '/');
  }, [location.pathname]);

  const handleClick = () => {
    navigate('/');
  }

  return (
    <TO_MAIN $isMain={isMain} onClick={handleClick}>на главную</TO_MAIN>
  )
}

const TO_MAIN = styled.span`
  display: none;

  @media (min-width: 768px) {
    display: ${({ $isMain }) => $isMain ? 'none' : 'block'};

    position: absolute;
    top: 5rem;
    right: 50px;

    font-size: 1rem;
    font-family: var(--primary-font);
    
    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;